import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';
import {
  BugReport,
  BugReportInput,
  BugReportViewedInput,
  CreateSystemStatusReportGQL,
  DeletePublishedSystemStatusReportsGQL,
  FeedbackAnalytics,
  FeedbackForAdmin,
  FeedbackGQL,
  FeedbackInput,
  GetBugReportsGQL,
  GetFeedbackAnalyticsGQL,
  GetFeedbacksGQL,
  GetSystemStatusReportsGQL,
  MarkBugReportsViewedGQL,
  ReportBugGQL,
  SystemStatusReport,
  SystemStatusReportInput,
  TogglePublishAllSystemStatusReportGQL,
  TogglePublishAllSystemStatusReportInput
} from '@cpd-app/generated';

@Injectable({
  providedIn: 'root'
})
export class SystemManagerService {
  constructor(
    private feedbackGQL: FeedbackGQL,
    private reportBugGQL: ReportBugGQL,
    private getBugReportsGQL: GetBugReportsGQL,
    private getSystemStatusReportsGQL: GetSystemStatusReportsGQL,
    private createSystemStatusReportGQL: CreateSystemStatusReportGQL,
    private togglePublishAllSystemStatusReportGQL: TogglePublishAllSystemStatusReportGQL,
    private deletePublishedSystemStatusReportsGQL: DeletePublishedSystemStatusReportsGQL,
    private markBugReportsViewedGQL: MarkBugReportsViewedGQL,
    private getFeedbacksGQL: GetFeedbacksGQL,
    private getFeedbackAnalyticsGQL: GetFeedbackAnalyticsGQL
  ) {}

  public feedback(feedback: FeedbackInput): Observable<number> {
    return this.feedbackGQL.mutate({ feedback }).pipe(
      map((result) => {
        return result.data.feedback.code;
      })
    );
  }

  public reportBug(input: BugReportInput): Observable<BugReport> {
    return this.reportBugGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data.reportBug;
      })
    );
  }

  public createSystemStatusReport(
    input: SystemStatusReportInput
  ): Observable<SystemStatusReport> {
    return this.createSystemStatusReportGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data.createSystemStatusReport;
      })
    );
  }

  public togglePublishAllSystemStatusReport(
    input: TogglePublishAllSystemStatusReportInput
  ): Observable<SystemStatusReport[]> {
    return this.togglePublishAllSystemStatusReportGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data.togglePublishAllSystemStatusReport;
      })
    );
  }

  public getBugReports(): Observable<BugReport[]> {
    return this.getBugReportsGQL.fetch().pipe(
      map((result) => {
        return result.data.getBugReports || [];
      })
    );
  }

  public getFeedbacks(): Observable<FeedbackForAdmin[]> {
    return this.getFeedbacksGQL.fetch().pipe(
      map((result) => {
        return result.data.getFeedbacks || [];
      })
    );
  }

  public getSystemStatusReports(): Observable<SystemStatusReport[]> {
    return this.getSystemStatusReportsGQL.fetch().pipe(
      map((result) => {
        return result.data.getSystemStatusReports || [];
      })
    );
  }

  public getFeedbackAnalytics(): Observable<FeedbackAnalytics> {
    return this.getFeedbackAnalyticsGQL.fetch().pipe(
      map((result) => {
        return result.data.getFeedbackAnalytics;
      })
    );
  }

  public deletePublishedSystemStatusReport(ids: string[]): Observable<boolean> {
    return this.deletePublishedSystemStatusReportsGQL.mutate({ ids }).pipe(
      map((result) => {
        return result.data.deletePublishedSystemStatusReports;
      })
    );
  }

  public markBugReportsViewed(
    input: BugReportViewedInput
  ): Observable<BugReport[]> {
    return this.markBugReportsViewedGQL.mutate({ input }).pipe(
      map((result) => {
        return result.data.markBugReportsViewed || [];
      })
    );
  }
}
